module.exports = __webpack_public_path__ + "img/inversion.0c7d590e.png";